import React, { useState } from "react";
import Grid from "../layout/grid";
import InputMask from "react-input-mask";
import { useEffect } from "react";
import { detectarMascara } from "../../utils/detectarMascara";

export function PhoneInput(props) {
    const inputProps = props.input || {};
    const valor = inputProps.value || props.value || "";
    const onChange = inputProps.onChange || props.onChange;

    const [mask, setMask] = useState("");

    function handleChange(e) {
        const newValue = e.target.value;
        const newMask = detectarMascara(newValue);

        if (newMask !== mask) {
            setMask(newMask);
        }

        if (onChange) onChange(newValue);
    }

    // ⚠️ Aplica máscara automaticamente se já vier valor inicial
    useEffect(() => {
        if (valor) {
            setMask(detectarMascara(valor));
        }
    }, [valor]);

    return (
        <Grid cols={props.cols}>
            <div className="form-group" style={props.style || {}}>
                <label htmlFor={props.name}>{props.label}</label>

                <InputMask
                    {...inputProps}
                    className="form-control"
                    mask={mask}
                    maskChar={props.maskChar || ""}
                    placeholder={props.placeholder || "Formatos aceitos: 0800 xxxx xxxx, (DD) xxxx-xxxx ou (DD) xxxxx-xxxx"}
                    alwaysShowMask={props.alwaysShowMask}
                    readOnly={props.readOnly}
                    value={valor}
                    onChange={handleChange}
                    type="text"
                />
            </div>
        </Grid>
    );
}
